<template>
  <div class="box">
    <div class="background">
      <div class="header">
        <div class="Tradingvolume">
          <div class="top">
            <div class="title">Blocks</div>
            <div class="add">
              <img src="../../image/PartitionSelection/Union.png" alt="" />
            </div>
          </div>
          <div class="middle">
            <div class="title">
              <div class="symbol">$</div>
              区块交易量
            </div>
            <div class="num">{{ block_txns }}</div>
          </div>
          <div class="bottom"></div>
        </div>
        <div class="chartData">
          <div class="head">
            <div class="left">
              <div class="title">Txns：</div>
              <div class="num">{{ txns_count }}</div>
            </div>
            <div class="lists">
              <div class="data_list" :class="{ dataActive: dataActive === item.id }" v-for="item in timeList" :key="item.id" @click="changedataActive(item)">
                {{ item.time }}
              </div>
            </div>
          </div>
          <div class="echarts" ref="chart"></div>
        </div>
      </div>
    </div>
    <div class="blocklists">
      <div class="lists">
        <div class="head"></div>
        <div class="title">最近区块</div>
        <div class="list">
          <ul>
            <li>时间</li>
            <li>区块</li>
            <li>交易量</li>
            <li>哈希</li>
          </ul>
          <div class="ul" v-for="item in blockLately" :key="item.trans_hash">
            <div class="li">{{ item.time }}</div>
            <div class="li">{{ item.number }}</div>
            <div class="li">{{ item.txns_num }}</div>
            <div class="li">{{ String(item.trans_hash).slice(0, 16) + '...' + String(item.trans_hash).slice(-14) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
export default {
  name: 'PartitionSelection',
  data() {
    return {
      timeList: [
        {
          id: 1,
          time: '1M',
        },
        {
          id: 3,
          time: '3M',
        },
        {
          id: 6,
          time: '6M',
        },
      ],
      dataActive: 1,
      block_data: [],
      txns_data: [],
      block_txns: null,
      txns_count: null,
      blockLately: [],
    }
  },
  mounted() {
    this.gettrendData()
    this.getblockLately()
  },
  methods: {
    changedataActive(item) {
      this.dataActive = item.id
      this.gettrendData()
    },
    gettrendData() {
      this.$axios
        .post('/index/web/trendData', {
          sliceno: sessionStorage.getItem('Sliceno'),
          month: this.dataActive,
        })
        .then((res) => {
          this.block_data = res.data.data.block_data
          this.txns_data = res.data.data.txns_data
          this.block_txns = res.data.data.block_txns
          this.txns_count = res.data.data.txns_count
          this.initChart()
        })
        .catch((error) => {
          // Error is already handled by interceptor
          console.error('Failed to fetch trend data:', error)
          // Set default values to prevent UI issues
          this.block_data = []
          this.txns_data = []
          this.block_txns = []
          this.txns_count = 0
        })
    },
    getblockLately() {
      this.$axios
        .post('/index/web/blockLately', {
          sliceno: sessionStorage.getItem('Sliceno'),
        })
        .then((res) => {
          this.blockLately = res.data.data
        })
        .catch((error) => {
          // Error is already handled by interceptor
          console.error('Failed to fetch recent blocks:', error)
          // Set default empty array to prevent UI issues
          this.blockLately = []
        })
    },
    initChart() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(this.$refs.chart)
      // 指定图表的配置项和数据
      myChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none',
            label: {
              backgroundColor: '#6a7985',
            },
          },
        },
        grid: {
          left: '-2%',
          right: '0%',
          bottom: '3%',
          containLabel: true,
        },
        legend: {
          data: ['Txns', 'Blocks'],
          icon: 'circle',
          right: '91px',
          bottom: '0px',
          orient: 'horizontal',
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.block_data.map((item) => {
            return item.data
          }),
          show: false,
        },
        yAxis: {
          type: 'value',
          show: false,
        },
        series: [
          {
            name: 'Txns',
            type: 'line',
            lineStyle: {
              color: '#5A55D2',
              width: 3,
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#5a55d23d',
                },
                {
                  offset: 1,
                  color: '#5a55d200',
                },
              ]),
            },
            data: this.txns_data.map((item) => {
              return item.txns_num
            }),
            symbol: 'circle',
            symbolSize: 30,
            showSymbol: false,
            itemStyle: {
              color: new echarts.graphic.RadialGradient(0.5, 0.5, 0.5, [
                {
                  offset: 0,
                  color: '#5A55D2', // 渐变色的起始颜色
                },
                {
                  offset: 1,
                  color: '#5A55D233', // 渐变色的结束颜色
                },
              ]),
            },
          },
          {
            name: 'Blocks',
            type: 'line',
            lineStyle: {
              color: '#00dea3',
              width: 3,
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#00dea33d',
                },
                {
                  offset: 1,
                  color: '#00dea300',
                },
              ]),
            },
            data: this.block_data.map((item) => {
              return item.block_num
            }),
            symbol: 'circle',
            symbolSize: 30,
            showSymbol: false,
            itemStyle: {
              color: new echarts.graphic.RadialGradient(0.5, 0.5, 0.5, [
                {
                  offset: 0,
                  color: '#00DEA3', // 渐变色的起始颜色
                },
                {
                  offset: 1,
                  color: '#00dea333', // 渐变色的结束颜色
                },
              ]),
            },
          },
        ],
      })
    },
  },
}
</script>
<style lang="scss" src="./PartitionSelection.scss" scoped></style>
